// src/i18n/i18n.js
// Install: npm install react-i18next@14.1.3 i18next@23.16.8 --legacy-peer-deps
// Add as first import in src/index.js:  import './i18n/i18n';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import de from '../locales/de.json';
import ar from '../locales/ar.json';

const saved = localStorage.getItem('transportily_lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      ar: { translation: ar },
    },
    lng: saved,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    // Critical: makes init synchronous so components don't render before ready
    initImmediate: false,
    react: {
      useSuspense: false,
    },
  });

export default i18n;